module.exports = __webpack_public_path__ + "static/icons-firstview-c41c1073220b9a70e99a7f99876fda59.png";